import { render, staticRenderFns } from "./Npwp.vue?vue&type=template&id=188b25d2&"
import script from "./Npwp.vue?vue&type=script&lang=js&"
export * from "./Npwp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports